import React, { useEffect, useState } from 'react';
import { useLang } from '../../context/LanguageContext';
import { useTranslate } from '../../Hook/useTranslate';
import { getCatalog } from '../../services/catalogAPI';

// Allergen declaration for a dish (EU 1169/2011), shown before the dish can be added.
export default function AllergenLine({ allergens = [], note = '' }) {
  const t = useTranslate();
  const { lang } = useLang();
  const [labels, setLabels] = useState({});

  useEffect(() => {
    getCatalog()
      .then((c) => setLabels(Object.fromEntries((c.allergens || []).map((a) => [a.key, a[lang] || a.en]))))
      .catch(() => {});
  }, [lang]);

  const names = allergens.map((key) => labels[key] || key);
  return (
    <p className="menu-item-allergens" style={{ fontSize: '12px', color: '#9a3412', margin: '4px 0 0' }}>
      {names.length ? `${t("Allergens")}: ${names.join(', ')}` : t("No allergens declared - ask the restaurant if you have an allergy.")}
      {note ? ` · ${note}` : ''}
    </p>
  );
}
